var map = {
	"./assets/clickable/buildzoom.svg": "601f58ef76cf25bcb020",
	"./assets/disabled/buildzoom.svg": "967bc3004295d286681c",
	"./assets/original/buildzoom.svg": "30cce1e297643b745de8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b8085f2ca3af2bb3a41";